// SYN-2191 — limite de duração de vídeo por plano: catálogo fechado e conversão para minutos.
//
// Fonte única dos dois lados do admin (plano e override por assinatura) e de toda copy que
// escreve "N min". O backend recusa com 422 qualquer valor fora do catálogo (RN3/D4), então um
// 4º valor nasce aqui e nos dois dialogs de uma vez — antes cada dialog tinha a própria lista.

export const VIDEO_DURATION_LIMIT_CHOICES = [60, 180, 300];

export const DEFAULT_MAX_VIDEO_DURATION_SECONDS = 60;

/**
 * Segundos → minutos para a copy ("limite do seu plano (3 min)"). O catálogo é múltiplo de 60
 * e sai inteiro; qualquer outro valor cai numa casa decimal em vez de despejar
 * `1.5666666666666667` na tela.
 * @param {number} seconds
 * @returns {number}
 */
export const minutesOf = (seconds) => {
    const minutes = seconds / 60;
    return Number.isInteger(minutes) ? minutes : Math.round(minutes * 10) / 10;
};
